import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NvD3Module } from '../../../../widgets/nvd3';

import { CoreFiltersModule } from '../../../core.filters.module';
import { CoreWidgetsModule } from '../../../../widgets/core.widgets.module';

import { ProjectAdminChecksComponent } from './projectAdminChecks/project.admin.checks.component';
import { ProjectAdminChecksHelper } from './projectAdminChecks/project.admin.checks.service';
import { ProjectAdminModulesComponent } from './projectAdminModules/project.admin.modules.component';
import { ProjectAdminEditComponent } from './projectAdminEdit/project.admin.edit.component';
import { ProjectAdminHomepageComponent } from './projectAdminHomepage/project.admin.homepage.component';
import { ProjectAdminHomepageHeaderComponent } from './projectAdminHomepage/projectAdminHomepageHeader/project.admin.homepage.header.controller';
import { ProjectAdminOrgsComponent } from './projectAdminOrgs/project.admin.orgs.component';
import { ProjectAdminOrgRelationDeleteComponent } from './projectAdminOrgs/project.admin.orgs.relation.delete.modal';
import { ProjectAdminRolesComponent } from './projectAdminRoles/project.admin.roles.component';
import { ProjectAdminScmAclComponent } from './projectAdminScm/projectAdminScmAcl/project.admin.scm.acl.component';
import { ProjectAdminScmTabsComponent } from './projectAdminScm/project.admin.scm.tabs.component';
import { ProjectAdminScmComponent } from './projectAdminScm/project.admin.scm.component';
import { ProjectAdminSnapshotsComponent } from './projectAdminSnapshots/project.admin.snapshots.component';
import { ProjectAdminSnapshotDeleteModalComponent } from './projectAdminSnapshots/project.admin.snapshot.delete.modal';
import { ProjectAdminGroupsComponent } from './projectAdminGroups/project.admin.groups.component';
import { ProjectAdminGroupAddComponent } from './projectAdminGroups/projectAdminGroupAdd/project.admin.groups.add.component';
import { ProjectAdminGroupEditComponent } from './projectAdminGroups/projectAdminGroupEdit/project.admin.group.edit.component';
import { ProjectAdminGroupDeleteComponent } from './projectAdminGroups/projectAdminGroupDelete/project.admin.group.delete.component';
import { ProjectAdminTrackerComponent } from './projectAdminTracker/project.admin.tracker.component';
import { ProjectAdminTrackerDeleteComponent } from './projectAdminTracker/projectAdminTrackerDelete/project.admin.tracker.delete.component';
import { ProjectAdminTroveComponent } from './projectAdminTrove/project.admin.trove.component';
import { ProjectAdminNotificationsComponent } from './projectAdminNotifications/project.admin.notifications.component';
import { ProjectAdminHeaderComponent } from './projectAdminHeader/project.admin.header.component';
import { ProjectAdminAiFlowComponent } from './projectAdminAiFlow/project.admin.ai-flow.component';
import { KnowledgeIndexComponent } from './projectAdminKnowledgeIndex/knowledge-index.component';
import { KnowledgeIndexAdminService } from './projectAdminKnowledgeIndex/knowledge-index-admin.service';
import { KnowledgeIndexQueueModalComponent } from './projectAdminKnowledgeIndex/knowledge-index-queue-modal.component';
import { ProjectAdminKnowledgeIndexComponent } from './projectAdminKnowledgeIndex/project.admin.knowledge-index.component';
import { ProjectAdminWebhooksSubscriptionsComponent } from './projectAdminWebhooks/project.admin.webhooks.subscriptions.component';
import { ProjectAdminWebhooksDeliveriesComponent } from './projectAdminWebhooks/project.admin.webhooks.deliveries.component';
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CoreFiltersModule,
        CoreWidgetsModule,
        NvD3Module,
    ],
    providers: [
      ProjectAdminChecksHelper,
      KnowledgeIndexAdminService,
    ],
    exports: [
        ProjectAdminChecksComponent,
        ProjectAdminModulesComponent,
        ProjectAdminEditComponent,
        ProjectAdminHomepageComponent,
        ProjectAdminHomepageHeaderComponent,
        ProjectAdminOrgsComponent,
        ProjectAdminOrgRelationDeleteComponent,
        ProjectAdminRolesComponent,
        ProjectAdminScmAclComponent,
        ProjectAdminScmTabsComponent,
        ProjectAdminScmComponent,
        ProjectAdminSnapshotsComponent,
        ProjectAdminSnapshotDeleteModalComponent,
        ProjectAdminGroupsComponent,
        ProjectAdminGroupAddComponent,
        ProjectAdminGroupEditComponent,
        ProjectAdminGroupDeleteComponent,
        ProjectAdminTrackerComponent,
        ProjectAdminTrackerDeleteComponent,
        ProjectAdminTroveComponent,
        ProjectAdminNotificationsComponent,
        ProjectAdminHeaderComponent,
        ProjectAdminAiFlowComponent,
        KnowledgeIndexComponent,
        KnowledgeIndexQueueModalComponent,
        ProjectAdminKnowledgeIndexComponent,
        ProjectAdminWebhooksSubscriptionsComponent,
        ProjectAdminWebhooksDeliveriesComponent,
    ],
    declarations: [
      ProjectAdminChecksComponent,
      ProjectAdminModulesComponent,
      ProjectAdminEditComponent,
      ProjectAdminHomepageComponent,
      ProjectAdminHomepageHeaderComponent,
      ProjectAdminOrgsComponent,
      ProjectAdminOrgRelationDeleteComponent,
      ProjectAdminRolesComponent,
      ProjectAdminScmAclComponent,
      ProjectAdminScmTabsComponent,
      ProjectAdminScmComponent,
      ProjectAdminSnapshotsComponent,
      ProjectAdminSnapshotDeleteModalComponent,
      ProjectAdminGroupsComponent,
      ProjectAdminGroupAddComponent,
      ProjectAdminGroupEditComponent,
      ProjectAdminGroupDeleteComponent,
      ProjectAdminTrackerComponent,
      ProjectAdminTrackerDeleteComponent,
      ProjectAdminTroveComponent,
      ProjectAdminNotificationsComponent,
      ProjectAdminHeaderComponent,
      ProjectAdminAiFlowComponent,
      KnowledgeIndexComponent,
      KnowledgeIndexQueueModalComponent,
      ProjectAdminKnowledgeIndexComponent,
      ProjectAdminWebhooksSubscriptionsComponent,
      ProjectAdminWebhooksDeliveriesComponent,
    ],
})
export class ProjectAdminModule {
    constructor() { }
}
